import { createSvgIcon } from '@material-ui/core/utils';

export const Play = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path fill="currentColor" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
  </svg>,
  'Play'
);
